/**
 * Public memorial video card — optional manual embed for YouTube/Vimeo.
 */
import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { Button } from '../ui/button';
import { VideoLinkCard } from '../media/VideoLinkCard';
import { getVideoLink } from '../../utils/videoLink';

export function MemorialPublicVideoCard({ item }) {
  const [showEmbed, setShowEmbed] = useState(false);
  const link = item?.video_link || getVideoLink(item);
  if (!link?.video_url) return null;

  const embeddable = link.embeddable && link.video_embed_url;

  return (
    <div className="space-y-3" data-testid="memorial-public-video-card">
      <VideoLinkCard
        entity={{
          video_link: link,
          video_title: item.title || link.video_title,
          video_notes: item.description || link.video_notes,
        }}
        showExternalNote
      />
      {embeddable ? (
        <>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="rounded-full"
            onClick={() => setShowEmbed((v) => !v)}
          >
            <Play className="mr-1.5 h-3.5 w-3.5" />
            {showEmbed ? 'Hide preview' : 'Watch preview'}
          </Button>
          {showEmbed ? (
            <div className="overflow-hidden rounded-xl border border-[hsl(38_14%_86%)]">
              <iframe
                title={item.title || link.video_title || 'Video preview'}
                src={link.video_embed_url}
                className="aspect-video w-full"
                allow="accelerometer; autoplay; encrypted-media; picture-in-picture"
                loading="lazy"
              />
            </div>
          ) : null}
        </>
      ) : null}
    </div>
  );
}

export default MemorialPublicVideoCard;
